"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@Const/common");
const Button_1 = require("@Components/Buttons/Button");
const AddDescriptionForm_1 = __importDefault(require("@Components/OverclaimView/DocumentForms/AddDescriptionForm"));
const react_1 = __importStar(require("react"));
const UploadedDocument = (props) => {
    const { index, file, filesWereUploaded, browseFilePickerRef, uploadedFiles, setUploadedFiles } = props;
    const [description, setDescription] = (0, react_1.useState)('');
    const updateFileDescription = (newUpdatedDescription) => {
        setDescription(newUpdatedDescription);
        const updatedFiles = [...uploadedFiles];
        updatedFiles[index].description = newUpdatedDescription;
        setUploadedFiles(updatedFiles);
    };
    return (react_1.default.createElement("li", { key: index },
        react_1.default.createElement("div", { className: 'file-info' },
            react_1.default.createElement("img", { src: common_1.ICONS.documentIcon, alt: "file-icon" }),
            react_1.default.createElement("div", { className: 'file-preview-name-container' },
                react_1.default.createElement("b", null, file.name),
                react_1.default.createElement("div", null,
                    Math.floor(file.size / 1000),
                    " KB")),
            filesWereUploaded && react_1.default.createElement("img", { className: 'file-uploaded-check-icon', src: common_1.ICONS.check, alt: "check" }),
            !filesWereUploaded && (react_1.default.createElement(Button_1.Button, { className: 'remove-file-button', mainColor: true, type: 'tertiary', onClick: () => {
                    if (browseFilePickerRef.current) {
                        const modifiedFilesList = uploadedFiles.filter((f) => f !== file);
                        setUploadedFiles(modifiedFilesList);
                    }
                } }, "Remove"))),
        !filesWereUploaded && (react_1.default.createElement(AddDescriptionForm_1.default, { description: description, setDescription: (newUpdatedDescription) => {
                updateFileDescription(newUpdatedDescription);
            } }))));
};
exports.default = UploadedDocument;
